<div class="facial-recognition-image-uploader">
  <fgb-facial-recognition-uploader-header
    facialRecognitionHeading="{{ 'facial.recognition.photo.success.heading' | translate }}"
    facialRecognitionSubheading="{{ 'facial.recognition.photo.success.subheading' | translate }}"
    [stepCounter]="stepCounter"
    [showCloseButton]="true"
    (setStep)="setStep.emit($event)"
    (previousStepChange)="previousStepChange.emit()"
  ></fgb-facial-recognition-uploader-header>

  <div class="container facial-recognition-details-div mt-3 text-center">
    <div class="border facial-recognition-photo-div mb-2">
      <img
        *ngIf="imageSrc || uploadedImage.value"
        [src]="uploadedImage.value || imageSrc"
        width="100%"
        height="100%"
        alt="facial-recognition-photo"
      />
    </div>
    <div class="font-size-14 success-photo-details-heading mt-4 text-success">
      {{ 'facial.recognition.photo.success.details.heading' | translate }}
    </div>
    <div class="font-size-14 success-photo-details-subheading">{{ 'facial.recognition.photo.success.details' | translate }}</div>
    <ng-container *ngIf="closeBrowser">
      <div class="font-size-14 success-photo-details-subheading">
        {{ 'facial.recognition.photo.success.close.browser' | translate }}
      </div>
    </ng-container>
  </div>

  <div *ngIf="!closeBrowser" class="container facial-recognition-buttons-div">
    <fgb-facial-recognition-uploader-button [facialRecognitionButtonType]="6"></fgb-facial-recognition-uploader-button>
  </div>
</div>
